import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectFeatureFlagActiveFromProps } from 'reducers/featureFlags/selectors';

const renderResult = (isAllowed, children, permissionDeniedComponent) => {
  if (typeof children === 'function') {
    return children(isAllowed);
  }

  return isAllowed ? children : !permissionDeniedComponent ? null : permissionDeniedComponent;
};

function FeatureFlag({ not, children, isEnabled, notEnabledComponent }) {
  return renderResult(not ? !isEnabled : isEnabled, children, notEnabledComponent);
}

FeatureFlag.propTypes = {
  isEnabled: PropTypes.bool,
  not: PropTypes.bool,
  flag: PropTypes.string.isRequired,
  notEnabledComponent: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

FeatureFlag.defaultProps = {
  isEnabled: false,
  not: false,
};

const mapStateToProps = createStructuredSelector({
  isEnabled: makeSelectFeatureFlagActiveFromProps(),
});

export default connect(mapStateToProps)(FeatureFlag);
